import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { StructuredProcessData, StructuredProcessInstance, StructuredProcessInstanceStatusEnum, StructuredProcessIntroDoc, UserCompetenciesData } from './strcutredProcess-data';
import { APIS } from 'src/app/apis';
import { HttpClient } from '@angular/common/http';
import { AbstractStructuredProcessService } from './structured-process.abstract.service';
import { StructuredProcessArtifact, StructuredProcessArtifactType } from './structuredProcess-artifactData';

@Injectable({
  providedIn: 'root'
})
export class StructuredProcessService implements AbstractStructuredProcessService {
  private getStructuredProcessUrl = `${APIS.structuredProcess}/getStructuredProcess`;
  private getStructuredProcessInstanceUrl = `${APIS.structuredProcess}/getStructuredProcessInstance`;
  private startProcessUrl = `${APIS.structuredProcess}/startStructuredProcess`;
  private setStructuredProcessCurrentStepUrl = `${APIS.structuredProcess}/setStructuredProcessCurrentStep`;
  private setStructuredProcessStepStateFromUserUrl = `${APIS.structuredProcess}/setStructuredProcessStepStateFromUser`;
  private saveStructuredProcessArtifactUrl = `${APIS.structuredProcess}/saveStructuredProcessArtifact`;
  private getStructuredProcessArtifactUrl = `${APIS.structuredProcess}/getStructuredProcessArtifact`;
  private resetStructuredProcessArtifactUrl = `${APIS.structuredProcess}/resetStructuredProcessArtifact`;
  private exportStructuredProcessWorkplanUrl = `${APIS.structuredProcess}/exportStructuredProcessWorkplan`;
  constructor(private http: HttpClient) { }

  public getStructuredProcess(processId: string = ""): Observable<StructuredProcessData> {
    return this.http.get<StructuredProcessData>(`${this.getStructuredProcessUrl}?processId=${processId}`)
    .pipe(
      map(proc => {
        if (proc.introDoc && typeof proc.introDoc === 'string') {
          try {
            proc.introDoc = JSON.parse(proc.introDoc);
          } catch (e) {
            console.error('Failed to parse introDoc', e);
            proc.introDoc = "";
          }
        }
        return proc;
      })
    );

  } 

  public getStructuredProcessInstance(): Observable<StructuredProcessInstance> {
    return this.http.get<StructuredProcessInstance>(`${this.getStructuredProcessInstanceUrl}`);
  }

  public startProcess(): Observable<StructuredProcessInstance> {
    return this.http.post<StructuredProcessInstance>(`${this.startProcessUrl}`, {});
  }

  public setStructuredProcessCurrentStep(stepId: string): Observable<StructuredProcessInstance> {
    return this.http.put<StructuredProcessInstance>(`${this.setStructuredProcessCurrentStepUrl}?stepId=${stepId}`, {});
  }

  public setStructuredProcessStepStateFromUser(stepId: string, state: StructuredProcessInstanceStatusEnum): Observable<StructuredProcessInstance> {
    return this.http.put<StructuredProcessInstance>(`${this.setStructuredProcessStepStateFromUserUrl}?stepId=${stepId}&state=${state}`, {});
  }

  public saveStructuredProcessArtifact(structuredProcessArtifact: StructuredProcessArtifact): Observable<StructuredProcessArtifact> {
    return this.http.post<StructuredProcessArtifact>(`${this.saveStructuredProcessArtifactUrl}`, structuredProcessArtifact);
  }

  public getStructuredProcessArtifact(artifactType: StructuredProcessArtifactType): Observable<StructuredProcessArtifact | null> {
    return this.http.get<StructuredProcessArtifact>(`${this.getStructuredProcessArtifactUrl}?artifactType=${artifactType}`);
  }

  public resetStructuredProcessArtifact(artifactType: StructuredProcessArtifactType): Observable<StructuredProcessInstance> {
    return this.http.put<StructuredProcessInstance>(`${this.resetStructuredProcessArtifactUrl}?artifactType=${artifactType}`, {});
  }

  public exportStructuredProcessWorkplan(processId: string): Observable<ArrayBuffer> {
    return this.http.get(`${this.exportStructuredProcessWorkplanUrl}?processId=${processId}`, { responseType: 'arraybuffer' });
  }

}
